// VideoDetails.js

import React, { useEffect, useState } from 'react';
import InstallationVideoBitmovin from './InstallationVideoBitmovin'; // Import the Bitmovin player component
import { Container, Grid } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { videoList } from './InstallationVideoNew';
import { faqVideoList } from './Faqs';

const VideoDetail = () => {
  const location = useLocation();
  const { id } = useParams();
  const [video, setVideo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let videoFile;

    if (location?.state?.video) {
      videoFile = location.state.video;
    } else if (location.pathname.includes("Flame-Test") && faqVideoList?.length) {
      videoFile = faqVideoList.find((videoItem) => videoItem.id === id);
    } else if (videoList?.length) {
      videoFile = videoList.find((videoItem) => videoItem.id === id);
    }

    if (videoFile) {
      setVideo(videoFile);
    }

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, videoList, faqVideoList]);
  return (
    <div>

      {loading ? <></> : video && (
        <>
          <Container maxWidth="lg" >
            <div className='container'>
              <Grid container>
                <Grid size={{ xs:12, md:10, sm:12, lg:1.5,}} >
                </Grid>
                <Grid size={{ xs:12, md:10, sm:12, lg:9, }} >
                  <div className='widget-wrap'>
                    <InstallationVideoBitmovin videoUrl={video?.url} poster={video?.poster} />
                  </div>
                  <div className='elementor-wrap-div '>
                    <div className='elementor-col  elementor-m-col '>
                      <h3 className='heading-title'> {video?.maintitle} </h3>
                    </div>
                    <div className='divider' style={{ margin: "1% 0 0 0" }}></div>
                    <div className='paragraph'>
                      <p>{video?.title}</p>
                    </div>
                  </div>
                </Grid>
                <Grid size={{ xs:12, md:10, sm:12, lg:1.5, }} >
                </Grid>

              </Grid>
            </div>
          </Container>
        </>
      )}

    </div>
  );
};

export default VideoDetail;
